import { datadog } from '@sg/expo-datadog-client';

export const exitApp = async () => {
  const { exitApp } = await import('@logicwind/react-native-exit-app');

  datadog.logger.warn('EXIT_APP | Intentional app restart');
  exitApp();
};
